module.exports = __webpack_public_path__ + "static/HarrisTeeter_pin_hover-02173f94421590b068b0370ea9a976dd.png";